import React from "react";
import { BackgroundColor } from "types/componentBackground";
import LinkCard from "components/Card/LinkCard";
import { BlockContent } from "components/BlockContent";
import { OfferCard } from "components/OfferCard/type";
import { dateFromOptionalDate } from "src/utils/date";
import * as styles from "./OfferSliderCard.module.scss";
import { isBlockContentValuePresent } from "@silversea-ssc/ui-components-react";

interface OfferSliderCardProps {
  offer: OfferCard;
  cardBackgroundColor?: BackgroundColor;
}

const OfferSliderCard: React.FC<
  React.PropsWithChildren<OfferSliderCardProps>
> = ({ offer, cardBackgroundColor }) => {
  const title = offer.cardContent?.title;
  const altText = typeof title == "string" ? title : offer.trackName;
  if (!isOfferSliderCardValid(offer)) {
    console.debug(
      "skipping offer card rendering with no title",
      offer.configurationCode
    );
    return null;
  }

  return (
    <LinkCard
      backgroundColor={cardBackgroundColor}
      image={offer.cardContent?.image}
      imageAltText={altText}
      title={
        <div className={styles.cardTitle}>
          <BlockContent
            value={offer.cardContent?.title}
            tokens={offer.tokenValues}
          />
        </div>
      }
      description={
        <BlockContent
          value={offer.cardContent?.description}
          tokens={offer.tokenValues}
        />
      }
      action={{ href: offer.fullPath }}
      expirationDate={dateFromOptionalDate(offer.toDate)}
    />
  );
};

export const OfferSliderCardLoading: React.FC<
  React.PropsWithChildren<Omit<OfferSliderCardProps, "offer">>
> = ({ cardBackgroundColor }) => {
  return (
    <LinkCard
      backgroundColor={cardBackgroundColor}
      image={undefined}
      imageAltText=""
      title={<span>&nbsp;</span>}
      description={<div style={{ height: "150px" }}>&nbsp;</div>}
      action={{ href: "#" }}
    />
  );
};

export const isOfferSliderCardValid = (
  props: OfferSliderCardProps["offer"]
): boolean => {
  return isBlockContentValuePresent(props.cardContent?.title);
};

export default OfferSliderCard;
